import { render, staticRenderFns } from "./afterShopDetails.vue?vue&type=template&id=3d245ca4&scoped=true&"
import script from "./afterShopDetails.vue?vue&type=script&lang=js&"
export * from "./afterShopDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterShopDetails.vue?vue&type=style&index=0&id=3d245ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d245ca4",
  null
  
)

export default component.exports